module.exports = __webpack_public_path__ + "4544df7de431652dec5d8c5dd5ec8201.png";